import React from 'react';
import ParticipantStrip from '../ParticipantStrip/ParticipantStrip';
import { styled } from '@material-ui/core/styles';
import MainParticipant from '../MainParticipant/MainParticipant';

const Container = styled('div')({
  position: 'relative',
});

const MainParticipantContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
}));

export default function Room() {
  return (
    <Container>
      <ParticipantStrip />
      <MainParticipantContainer>
        <MainParticipant />
      </MainParticipantContainer>
    </Container>
  );
}
